import api from './api';

export interface FloorCardAction {
  label: string;
  kind: 'resolve' | 'chase' | 'escalate' | 'view';
  route?: string | null;
}

export interface FloorCard {
  // Fulfillment's real backend only ever sends the 4 literal values below;
  // widened to `string` so the same card shape/component can be reused for
  // synthetic, client-computed cards (e.g. Ace's Proxy landing-state cards)
  // that need more distinct React keys than this closed union allows.
  key: 'exceptions' | 'escalations' | 'aging' | 'blocked' | (string & {});
  fact: string;
  recommendation: string;
  severity: 'danger' | 'amber' | 'purple' | 'neutral';
  count: number;
  mocked?: boolean;
  action: FloorCardAction;
}

export interface FloorState {
  generated_at: string;
  is_clear: boolean;
  cards: FloorCard[];
}

export async function getFloorState(): Promise<FloorState> {
  const r = await api.get<FloorState>('/api/v1/queues/floor-state');
  return r.data;
}
